import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const VisitTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const trackVisit = async () => {
      try {
        await axios.post(`${API}/track-visit`, {
          user_agent: navigator.userAgent,
          page_visited: location.pathname,
          referrer: document.referrer || null
        });
      } catch (error) {
        // Silent fail - don't affect user experience
        console.debug('Visit tracking failed:', error);
      }
    };

    trackVisit();
  }, [location.pathname]);

  return null;
};

export default VisitTracker;
